import { MutationTree } from 'vuex';
import Cookies from 'js-cookie';
import { ProfileState } from '@/store/profile/types';
import { documentLinkTokenCookie } from '@/utils/config';

const mutations: MutationTree<ProfileState> = {
  login(state, payload: ProfileState) {
    const { user, session } = payload;
    state.user = user;
    state.session = session;
    if (session) {
      Cookies.set('session', session);
    }
  },
  logout(state) {
    state.user = undefined;
    state.session = undefined;
    Cookies.remove('session');
    Cookies.remove(documentLinkTokenCookie.name, documentLinkTokenCookie.attributes);
  },
  setSession(state, payload) {
    state.session = payload;
    if (payload?.token) {
      Cookies.set(documentLinkTokenCookie.name, payload.token, documentLinkTokenCookie.attributes);
    }
  },
};

export default mutations;
